import Vue from 'vue'
import Router from 'vue-router'

import store from './store'
import Home from './views/Home.vue'
import Shop from './views/Shop.vue'
import CustomProduct from './views/CustomProduct.vue'
import TransportRequest from './views/TransportRequest.vue'
import Cart from './views/Cart.vue'
import Account from './views/Account.vue'
import Login from './views/auth/Login.vue'
import Logout from './views/auth/Logout.vue'
import ForgotPassword from './views/auth/ForgotPassword.vue'
import ResetPassword from './views/auth/ResetPassword.vue'
import Page from './views/Page.vue'

Vue.use(Router)

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                auth: true
            }
        },
        {
            path: '/shop/vrij-product',
            name: 'custom-product',
            component: CustomProduct,
            meta: {
                auth: true
            }
        },
        {
            path: '/transport-aanvraag',
            name: 'transport-request',
            component: TransportRequest,
            meta: {
                auth: true
            }
        },
        {
            path: '/shop/:category?',
            name: 'shop',
            component: Shop,
            meta: {
                auth: true
            }
        },
        {
            path: '/cart',
            name: 'cart',
            component: Cart,
            meta: {
                auth: true
            }
        },
        {
            path: '/account',
            name: 'account',
            component: Account,
            meta: {
                auth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/logout',
            name: 'logout',
            component: Logout,
        },
        {
            path: '/wachtwoord-vergeten',
            name: 'forgotPassword',
            component: ForgotPassword,
        },
        {
            path: '/wachtwoord-reset/:token?',
            name: 'resetPassword',
            component: ResetPassword,
        },
        {
            path: '/:slug',
            name: 'page',
            component: Page,
            meta: {
                auth: true
            }
        },
    ]
})

router.beforeEach((to, from, next) => {

    if (to.meta.auth) {
        if (!store.getters.isAuthorized) {
            next('/login');
        }
    } else {
        next()
    }

    next()
});

export default router